import { useState } from 'react';
import { UserApi } from '../../../api';
import { useContainer } from '../../useContainer';

const useDisableOrEnableNotification = () => {
    const userApi: UserApi = useContainer(UserApi);
    const [isReady, setIsReady] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [data, setData] = useState<boolean | null>(null);
    const [isLoading, setIsLoading] = useState(false);

    const toggleNotification = async (notificationName: string, enabled: boolean) => {
        setIsLoading(true);
        setError(null);

        try {
            const { exec } = userApi.disableOrEnableNotification({
                params: {
                    name: notificationName,
                },
                body: { enabled: enabled },
                onSuccess: res => {
                    setData(res.body.enabled);
                    setIsReady(true);
                    setIsLoading(false);
                },
                onError: err => {
                    setError(err.message);
                    setIsReady(false);
                    setIsLoading(false);
                },
                onFinally: () => {
                    setIsReady(true);
                    setIsLoading(false);
                },
            });

            await exec();

            return true;
        } catch (err) {
            setIsLoading(false);
            return false;
        }
    };

    return {
        isReady,
        error,
        data,
        isLoading,
        toggleNotification,
    };
};

export default useDisableOrEnableNotification;
